import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { NavController } from '@ionic/angular';
import { quickWebLogger } from '@quickweb/logger';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit {

  idLabel = 'error-page';
  label = 'erro';
  headerId = 'error';
  titlePage = '';

  constructor(public router: NavController,
              private title: Title,
              ) {}

  ngOnInit() {
    this.setTitle();
  }

  setTitle() {
    this.title.setTitle(this.headerId);
    quickWebLogger.rum.startView({ pageName: `${location.hash}` });
  }

  getPageId(): string {
    return this.headerId;
  }

  back() {
    this.router.back();
  }
}
